const states = {
    "Acre": "AC",
    "Alagoas": "AL",
    "Amapá": "AP",
    "Amazonas": "AM",
    "Bahia": "BA",
    "Ceará": "CE",
    "Distrito Federal": "DF",
    "Espírito Santo": "ES",
    "Goiás": "GO",
    "Maranhão": "MA",
    "Mato Grosso": "MT",
    "Mato Grosso do Sul": "MS",
    "Minas Gerais": "MG",
    "Pará": "PA",
    "Paraíba": "PB",
    "Paraná": "PR",
    "Pernambuco": "PE",
    "Piauí": "PI",
    "Rio de Janeiro": "RJ",
    "Rio Grande do Norte": "RN",
    "Rio Grande do Sul": "RS",
    "Rondônia": "RO",
    "Roraima": "RR",
    "Santa Catarina": "SC",
    "São Paulo": "SP",
    "Sergipe": "SE",
    "Tocantins": "TO"
}

const normalizedStates = Object.keys(states).reduce((acc, key) => {
    const normalizedKey = key.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase();
    acc[normalizedKey] = states[key];
    return acc;
}, {});

export function getStateUf(state) {
    if (!state) return "";
    if (state.length === 2) return state.toUpperCase(); // Já é uma sigla
    
    const normalizedInput = state.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase();
    return normalizedStates[normalizedInput] || state;
}


// WEBPACK FOOTER //
// ./src/views/Fiscal/NFSe/emit/utils/index.js